/**
 * Template categories by type for multi-category template system
 */

import { PRESENTATION_TEMPLATE_CATEGORIES } from '@domain/sales-presentations/api/types';

export type TemplateType = 'presentation' | 'email' | 'document' | 'event';

export interface CategoryOption {
  value: string;
  label: string;
}

export const TEMPLATE_CATEGORIES: Record<TemplateType, CategoryOption[]> = {
  presentation: [
    { value: 'all', label: 'All Presentations' },
    ...PRESENTATION_TEMPLATE_CATEGORIES,
  ],
  email: [
    { value: 'all', label: 'All Emails' },
    { value: 'welcome', label: 'Welcome' },
    { value: 'promotion', label: 'Promotion' },
    { value: 'newsletter', label: 'Newsletter' },
    { value: 'follow-up', label: 'Follow-up' },
    { value: 'outreach', label: 'Outreach' },
  ],
  document: [
    { value: 'all', label: 'All Documents' },
    { value: 'contract', label: 'Contract' },
    { value: 'doc-proposal', label: 'Proposal' },
    { value: 'sales-brief', label: 'Sales Brief' },
    { value: 'one-pager', label: 'One-Pager' },
    { value: 'product-sheet', label: 'Product Sheet' },
  ],
  event: [
    { value: 'all', label: 'All Events' },
    { value: 'webinar', label: 'Webinar' },
    { value: 'demo', label: 'Demo' },
    { value: 'workshop', label: 'Workshop' },
    { value: 'conference', label: 'Conference' },
    { value: 'meeting', label: 'Meeting' },
  ],
};

export const CREATE_CATEGORY_OPTIONS: Record<TemplateType, CategoryOption[]> = {
  presentation: [...PRESENTATION_TEMPLATE_CATEGORIES],
  email: [
    { value: 'welcome', label: 'Welcome' },
    { value: 'promotion', label: 'Promotion' },
    { value: 'newsletter', label: 'Newsletter' },
    { value: 'follow-up', label: 'Follow-up' },
    { value: 'outreach', label: 'Outreach' },
  ],
  document: [
    { value: 'contract', label: 'Contract' },
    { value: 'doc-proposal', label: 'Proposal' },
    { value: 'sales-brief', label: 'Sales Brief' },
    { value: 'one-pager', label: 'One-Pager' },
    { value: 'product-sheet', label: 'Product Sheet' },
  ],
  event: [
    { value: 'webinar', label: 'Webinar' },
    { value: 'demo', label: 'Demo' },
    { value: 'workshop', label: 'Workshop' },
    { value: 'conference', label: 'Conference' },
    { value: 'meeting', label: 'Meeting' },
  ],
};
